import React from 'react';
import injectSheet from 'react-jss';
import cn from 'classnames';
import BaseCard from '../Card';
import theme, { makeResponsiveSettings } from '../../styles/theme';
import { mergeTitleAndCopyAndOverlayClassNames } from '../../helpers/mergeClassNames';

const Card = ({
  classes, className, classNames, format, formats, aspect, isOverlay, isDark, ...rest
}) => (
  <BaseCard
    {...rest}
    className={cn(className, classes[format])}
    classNames={mergeTitleAndCopyAndOverlayClassNames(classNames, classes)}
    format={format}
    formats={formats}
    isOverlay={isOverlay}
    ready
  />
);

Card.propTypes = BaseCard.propTypes;
Card.defaultProps = BaseCard.defaultProps;

const getMobileOverlayBackground = opacity => {
  const opacityOptions = {
    'No opacity': 'initial',
    'Dark opacity': theme.colors.darkOpacity25,
    'Light opacity': theme.colors.whiteOpacity25,
  };
  return opacityOptions[opacity] || 'initial';
};

const getDesktopOverlayBackground = opacity => {
  const opacityOptions = {
    'No opacity': 'initial',
    'Dark opacity': `linear-gradient(0deg, ${theme.colors.darkOpacity37}, ${theme.colors.darkOpacity0} 162px, ${theme.colors.darkOpacity0})`,
    'Light opacity': `linear-gradient(0deg, ${theme.colors.whiteOpacity37}, ${theme.colors.whiteOpacity0} 162px, ${theme.colors.whiteOpacity0})`,
  };
  return opacityOptions[opacity] || 'initial';
};

export const mobilePortraitWidth = 220;
export const twoColumnBreakpoint = mobilePortraitWidth * 2
  + theme.padding.gutter
  + theme.padding.horizontal * 2;

export default injectSheet({
  landscape: {
    '& $copy': {
      maxWidth: '100%',
      [theme.breakpoints.up('lg')]: {
        maxWidth: '75%',
      },
    },
  },
  title: {
    maxWidth: '100%',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '75%',
    },
    fontSize: 16,
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    },
    [theme.breakpoints.between(0, twoColumnBreakpoint)]: {
      fontSize: ({ isStackedOnMobileInOneColumn }) => (isStackedOnMobileInOneColumn ? 18 : null),
    },
  },
  copy: {
    marginBottom: theme.padding.gutter,
    '&:last-child': {
      marginBottom: 0,
    },
    fontSize: 14,
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.between(0, twoColumnBreakpoint)]: {
      fontSize: ({ isStackedOnMobileInOneColumn }) => (isStackedOnMobileInOneColumn ? 16 : null),
    },
  },
  overlayContainer: {
    marginBottom: 0,
    backgroundColor: ({ opacity }) => getMobileOverlayBackground(opacity.mobile),
    [theme.breakpoints.up('md')]: {
      backgroundColor: () => 'initial',
      backgroundImage: ({ opacity }) => getDesktopOverlayBackground(opacity.desktop),
    },
  },
  overlayTitle: {
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.between(0, twoColumnBreakpoint)]: {
      fontSize: ({ isStackedOnMobileInOneColumn }) => (isStackedOnMobileInOneColumn ? 20 : null),
    },
    ...makeResponsiveSettings([
      'color', 'isDark', isDark => (
        isDark ? theme.colors.brandBlack : theme.colors.white
      ),
    ]),
  },
})(Card);
